<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
          <li>
            <a href="http://www.providencefirst.com" target="_blank">
              ProvidenceFirst.com
            </a>
          </li>
          <li>
            <a href="http://www.providencefirst.com/?page_id=256" target="_blank">
              About
            </a>
          </li>
          <li>
            <a href="http://www.providencefirst.com/?page_id=251" target="_blank">
              Contact
            </a>
          </li>
          <li><a href="static/files/PFTC_Online_Portal_Terms_Conditions.pdf" target="_blank">Terms &amp; Conditions</a></li>
          <li><a href="static/files/PFTC_Online_Portal_Privacy_Policy.pdf" target="_blank">Privacy Policy</a></li>
        </ul>
      </nav>
      <div class="copyright pull-right">
        &copy; Providence First Trust Company
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/ContentFooter.vue